/**
 * OrgAdminRoute — ORG_ADMIN 전용 라우트 가드 (V1173)
 *
 * ORG_POWER / ORG_USER 접근 시 /dashboard로 리다이렉트.
 * 플랫폼 관리자(SUPER_ADMIN, ADMIN, OPERATOR)는 항상 통과.
 */

import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { isOrgAdmin, isPlatformAdmin } from '@/types/auth';

interface OrgAdminRouteProps {
  children: React.ReactNode;
}

export default function OrgAdminRoute({ children }: OrgAdminRouteProps) {
  const { user } = useAuthStore();

  if (!isPlatformAdmin(user) && !isOrgAdmin(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
